/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UpdateEquipmentModelRequest { 
    id: string;
    name: string;
    manufacturerId: string;
    hashrateUnitId: number;
    nominalHashrate: number;
    nominalPower: number;
    maxMotherBoardTemperature: number;
    maxProcessorTemperature: number;
    coinIds: Array<number>;
}

